/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ConvertItepApi } from "api"
import Axios from "axios"
import {
  ActionButton,
  Alert,
  AlertAlreadyStockOpname,
  DataStatus,
  useCheckStockOpname
} from "components"
import { Formik } from "formik"
import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { FormSection, TableSection } from "../Section"
import {
  formInitialValues,
  formSubmitMapper,
  formValidationSchema,
} from "../Utils"

const TambahConvertItem = ({ setNavbarTitle }) => {
  const history = useHistory()
  const location = useLocation()
  const [dataBahan, setDataBahan] = useState([])
  const [dropdown, setDropdown] = useState({
    bahan: [],
    gudang: [],
  })
  const [fetchingStatus, setFetchingStatus] = useState({
    loading: false,
    success: true,
  })
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  })

  const mappingDataBahan = (data) =>
    data.map((val) => ({
      value: val?.id_item_buaso,
      label: `${val.kode_item} | ${val.nama_item}`,
      idKelompok: val.id_kelompok,
      namaKelompok: val.nama_kelompok,
      idJenis: val.id_jenis,
      namaJenis: val.nama_jenis,
      idSatuan: val.id_satuan_pakai,
      namaSatuan: val.satuan_pakai,
      kodeItem: val.kode_item,
    }))
  const mappingDatagGudang = (data) =>
    data.map((val) => ({
      value: val?.id_gudang,
      label: val.nama_gudang,
    }))

  const getInitialValues = () => {
    setFetchingStatus({ loading: true, success: false })

    Axios.all([ConvertItepApi.getBahan(), ConvertItepApi.dropdownGudang()])
      .then(
        Axios.spread((bahan, gudang) => {
          setDropdown({
            bahan: mappingDataBahan(bahan.data.data ?? []),
            gudang: mappingDatagGudang(gudang.data.data ?? []),
          })
          setFetchingStatus({
            loading: false,
            success: true,
          })
        })
      )
      .catch(() => {
        setAlertConfig({
          show: false,
          variant: "primary",
          text: "Data gagal dimuat!",
        })
        setFetchingStatus({
          loading: false,
          success: false,
        })
      })
  }

  const formSubmitHandler = (values) => {
    ConvertItepApi.create(formSubmitMapper(values))
      .then(() => {
        history.push("/inventory/transaksi/convert-item", {
          alert: {
            show: true,
            variant: "primary",
            text: "Data berhasil disimpan!",
          },
          do: location?.state?.do,
        })
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal disimpan!",
        })
      })
      .finally(() => { })
  }

  useEffect(() => {
    setNavbarTitle("Convert Item")
    getInitialValues()
  }, [])

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues({}, dataBahan)}
      validationSchema={formValidationSchema}
      onSubmit={formSubmitHandler}
    >
      {(formik) => (
        <>
          <Alert
            show={alertConfig.show}
            variant={alertConfig.variant}
            text={alertConfig.text}
            showCloseButton={true}
            onClose={() =>
              setAlertConfig({
                ...alertConfig,
                show: false,
              })
            }
          />
          {fetchingStatus.loading ? (
            <DataStatus loading text="Memuat . . ." />
          ) : fetchingStatus.success ? (
            <form onSubmit={formik.handleSubmit}>
              <FormSection dropdown={dropdown} />
              <TableSection dropdown={dropdown?.bahan} />
              <AlertAlreadyStockOpname tanggal={formik?.values?.tglConvert} />
              <SubmitButton
                tanggal={formik?.values?.tglConvert}
                isSubmitting={formik.isSubmitting}
                hasDetail={formik?.values?.detail.length > 0}
              />
            </form>
          ) : (
            <DataStatus text="Data gagal dimuat" />
          )}
        </>
      )}
    </Formik>
  )
}

function SubmitButton({ tanggal, isSubmitting, hasDetail }) {
  const { isOpname } = useCheckStockOpname({ tanggal })

  return (
    <div className="text-right">
      <ActionButton
        type="action"
        className="btn btn-primary text-white"
        size="md"
        text="Simpan"
        disable={isOpname || !hasDetail}
        loading={isSubmitting}
      />
    </div>
  )
}

export default TambahConvertItem
